import { RouteUrlList } from '@/libs/RouteList';

/**
 * @todo 身分證件上傳
 */
const TradingRiskScorePostBack = [
    'POST',
    RouteUrlList.API_TradingRiskScorePostBack.path,
    {},
    200,
    {
        status: true,
        title: '',
        message: '',
        errorCode: ''
    }
];
export default TradingRiskScorePostBack;
